import { PropsWithChildren } from 'react'

import { Splitter as AntdSplitter } from 'antd'
import { createStyles } from 'antd-style'

import { SplitterProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  splitter: {
    [`& .${prefixCls}-splitter-bar`]: {
      marginInline: token.margin
    }
  }
}))

export const Splitter = ({
  autoSaveId,

  /* ************************************************************************** */
  /*                             Antd Splitter Props                            */
  /* ************************************************************************** */
  className,
  ...restProps
}: PropsWithChildren<SplitterProps>) => {
  const { cx, styles } = useStyles()

  return (
    <AntdSplitter {...restProps} className={cx(styles.splitter, className)} />
  )
}

Splitter.Panel = AntdSplitter.Panel
